import {TrackingPromotionCreative} from '@aboutyou/legacy-tracking-sdk';
import {TrackBASMonitoring, TrackPromotions} from '@aboutyou/tracking';
import {ContentBlockImageTile} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {BASCampaignHeaderLogoTypes} from '../../features/AboutYouLogo/hooks/useBasCampaign';

export const BASHomepageBannerView: React.FC<{
  basCampaign: BASCampaignHeaderLogoTypes | null;
  sectionIndex?: number;
  className?: string;
}> = ({basCampaign, sectionIndex, className}) => {
  if (!basCampaign || !basCampaign.homePageBanner) {
    return (
      <TrackBASMonitoring
        basPromotionSource={TrackingPromotionCreative.BasBrowseTopBanner}
      />
    );
  }

  return (
    <StyledTrackPromotions
      data-testid="BASHomepageBannerTracked"
      promotion={{
        advertisement: {
          id: basCampaign.id,
          path: basCampaign.path,
          name: basCampaign.topBannerName || '',
        },
        source: TrackingPromotionCreative.BasBrowseTopBanner,
      }}
      streamPosition={sectionIndex! - 1}
      className={className}
    >
      <ContentBlockImageTile
        testId="BASHomepageBanner"
        href={basCampaign.path}
        image={{
          url: basCampaign.homePageBanner.imagePath,
          description: 'BAS Home Banner',
          aspectRatio: '3.4:1',
        }}
        importance="high"
      />
    </StyledTrackPromotions>
  );
};

const StyledTrackPromotions = styled(TrackPromotions)`
  margin-bottom: 4px;
`;
